import { render, staticRenderFns } from "./ConfigDialog.vue?vue&type=template&id=a8f72bfe&scoped=true&"
import script from "./ConfigDialog.vue?vue&type=script&lang=js&"
export * from "./ConfigDialog.vue?vue&type=script&lang=js&"
import style0 from "./ConfigDialog.vue?vue&type=style&index=0&id=a8f72bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f72bfe",
  null
  
)

export default component.exports